module.exports = __webpack_public_path__ + "static/media/relationship-img.12c86820.png";